import React from 'react';
import './floatingcontactbutton.css';

const IconCart = () => (
  <svg className="circular-cta-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);

const IconTruck = () => (
  <svg className="circular-cta-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="15" height="13" />
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const CircularCtaButton = ({ ringText, icon, label, href, ariaLabel, pathId }) => (
  <div className="circular-cta-wrap">
    <div className="circular-cta">
      {/* 바깥 원형 텍스트 (빙글빙글 회전) */}
      <svg className="circular-cta-ring" viewBox="0 0 200 200" aria-hidden="true">
        <defs>
          <path
            id={pathId}
            d="M 100, 100 m -70, 0 a 70, 70 0 1, 1 140, 0 a 70, 70 0 1, 1 -140, 0"
            fill="none"
          />
        </defs>
        <path
          className="circular-cta-ring-stroke"
          d="M 100, 100 m -70, 0 a 70, 70 0 1, 1 140, 0 a 70, 70 0 1, 1 -140, 0"
          fill="none"
          strokeWidth="0.5"
        />
        <text className="circular-cta-ring-text" fontSize="12" fontWeight="600" letterSpacing="0.08em">
          <textPath href={`#${pathId}`} startOffset="0">
            {ringText}
          </textPath>
        </text>
      </svg>
      {/* 중앙 흰 원 버튼 */}
      <button
        type="button"
        className="circular-cta-center"
        aria-label={ariaLabel}
        onClick={() => window.open(href, '_blank')}
      >
        <span className="circular-cta-icon" aria-hidden="true">{icon}</span>
        <span className="circular-cta-label" aria-hidden="true">{label}</span>
      </button>
    </div>
  </div>
);

const FloatingContactButton = () => {
  const mainUrl = 'https://www.xn--o39ap7bo6pk0bo2x.com';
  return (
    <div className="floating-buttons">
      <div className="floating-button-item">
        <CircularCtaButton
          pathId="circular-path-shop"
          ringText="MONGOFACTORY • STORE • 몽팩토리 • "
          icon={<IconCart />}
          label="몽팩토리"
          href="https://smartstore.naver.com/m-fact"
          ariaLabel="몽팩토리 바로가기"
        />
      </div>

      <div className="floating-button-item">
        <CircularCtaButton
          pathId="circular-path-delivery"
          ringText="DELIVERY • 배송 • 운송 • "
          icon={<IconTruck />}
          label="택배모임"
          href="https://cafe.naver.com/skydydck"
          ariaLabel="택배모임 바로가기"
        />
      </div>
    </div>
  );
};

export default FloatingContactButton;
